export default {
  message: {
    customerNumbersAssistant: {
      date: {
        title: 'Calculer les points à partir de la date X',
        warning:
          'Avec une date sélectionnée, les numéros principaux ne peuvent pas être déplacés !',
      },
      import: {
        openButton: 'Importer des numéros client',
        loadingModal: 'Chargement de la fenêtre...',
        title: 'Importer des numéros client depuis Excel',
        validateButton: 'Valider le fichier',
        submitButton: "Envoyer à l'API",
        submitButtonLoading: 'Envoi en cours...',
        selectWholesalerLabel: 'Grossiste',
        selectGroupLabel: 'Groupe',
        selectWholesalerPlaceholder: 'Sélectionner un grossiste',
        selectGroupPlaceholder: 'Sélectionner un groupe (optionnel)',
        requirementsTitle: 'Exigences du fichier',
        fileFormatRequirement: 'Fichier Excel uniquement : .xlsx ou .xls',
        headerRequirement:
          'La ligne d’en-tête doit être : Customer number, Email (colonnes A/B).',
        createdLabel: 'Créé',
        alreadyExistsLabel: 'Existe déjà',
        success: 'Le fichier Excel est valide.',
        submitSuccess: 'Les numéros client ont été importés avec succès.',
        previewTitle: 'Aperçu',
        summaryTitle: 'Résumé de validation',
        previewCount: '{count} lignes, {pageSize} lignes par page.',
        importableCountLabel: 'Peut être importé',
        skippedCountLabel: 'Sera ignoré',
        searchPlaceholder: 'Rechercher par ligne, numéro client, e-mail ou statut',
        confirmImportTitle: "Confirmer l'import",
        confirmImportQuestion: 'Voulez-vous importer maintenant les enregistrements disponibles ?',
        confirmImportButton: 'Importer maintenant',
        filters: {
          all: 'Tous',
          importable: 'Importables',
          skipped: 'Ignorés',
        },
        row: 'Ligne',
        customerNumber: 'Numéro client',
        email: 'E-mail',
        status: 'Statut',
        userExists: "L'utilisateur existe",
        customerNumberExists: 'Le numéro client existe',
        customerNumberExistsForEmail: 'Le numéro client existe pour cet e-mail',
        customerNumberOwnerEmail: 'E-mail du propriétaire du numéro client',
        conflictsFound: 'Des conflits ont été détectés. Corrigez-les avant import.',
        previousPage: 'Précédent',
        nextPage: 'Suivant',
        pageInfo: 'Page {current} / {total}',
        progressLabel: 'Progression',
        statusLabels: {
          available_for_import: "Disponible pour l'import",
          already_linked: 'Déjà lié',
          customer_number_linked_to_other_user: 'Numéro client lié à un autre utilisateur',
          user_not_found: 'Utilisateur introuvable',
          user_not_dealer: "L'utilisateur n'est pas dealer",
          user_in_other_group: "L'utilisateur est dans un autre groupe",
        },
        summaryLabels: {
          total_rows: 'Nombre total de lignes',
          available_for_import: "Disponible pour l'import",
          already_linked: 'Déjà lié',
          customer_number_linked_to_other_user: 'Lié à un autre utilisateur',
          user_not_found: 'Utilisateur introuvable',
          user_not_dealer: "L'utilisateur n'est pas dealer",
          user_in_other_group: "Utilisateur dans un autre groupe",
        },
        errors: {
          wholesalerRequired: 'Le grossiste est requis.',
          groupRequired: 'Le groupe est requis.',
          fileRequired: 'Le fichier Excel est requis.',
          emptyWorkbook: 'Le classeur Excel est vide.',
          invalidHeaders:
            'Le fichier doit contenir exactement 2 colonnes : numéro client et e-mail.',
          emptyRows: 'Le fichier ne contient aucune ligne de données.',
          firstTwoColumnsRequired:
            'Ligne {row} : la première et la deuxième colonne doivent être remplies.',
          invalidCustomerNumber:
            'Numéro client invalide à la ligne {row}. Utilisez uniquement des lettres et des chiffres.',
          invalidEmail: 'E-mail invalide à la ligne {row}.',
          invalidFileType: 'Seuls les fichiers Excel (.xlsx, .xls) sont autorisés.',
          readError: 'Impossible de lire le fichier Excel.',
          validateFirst: "Validez d'abord le fichier.",
          conflictsBeforeImport: "L'import est bloqué à cause de conflits de validation.",
          nothingToImport: "Aucun enregistrement n'est disponible pour l'import.",
          submitFailed: "Échec de l'envoi des enregistrements à l'API.",
        },
      },
    },
  },
}
